import {RouteBranch} from './route-branch';

export class PlanningRoute extends RouteBranch {}
